import _regeneratorKeys from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js";
import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import { Message } from 'element-ui';
import MemberNiceNameEdit from '../edit/index';
export default {
  components: {
    MemberNiceNameEdit: MemberNiceNameEdit
  },
  name: 'MatchmakerMemberList',
  data: function data() {
    return {
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      isSelect: this.checkauthority('matchmakerMemberList_select'),
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      activeName: '1',
      selectForm: {
        registerTime: [],
        noOrPhone: null,
        membershipAuditSts: 0,
        selectCitys: [],
        memberStats: null,
        sortType: 1,
        memberSts: 0,
        nickName: null,
        authorizationType: null,
        displayIs: 0,
        topIs: null,
        freeDisplayIs: null
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      provinces: [],
      citys: [],
      sex: [],
      memberV: [],
      memberTypes: [],
      memberSources: [],
      minAges: [],
      maxAges: [],
      educations: [],
      carPurchases: [],
      buyHouses: [],
      marriages: [],
      memberSumCounts: {}
    };
  },
  methods: {
    checkAuthType: function checkAuthType(type) {
      if (type === 1) {
        return '体验授权';
      } else if (type === 2) {
        return '总代授权';
      } else if (type === 3) {
        return '红娘推广授权';
      } else if (type === 4) {
        return '红娘推送授权';
      } else if (type === 5) {
        return '代理授权';
      } else if (type === 6) {
        return '超级代理授权';
      } else if (type === -1) {
        return '暂不授权';
      } else {
        return '';
      }
    },
    exportExcel: function exportExcel() {
      var par = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        noOrPhone: this.selectForm.noOrPhone,
        membershipAuditSts: this.selectForm.membershipAuditSts,
        membership: 3,
        sortType: this.selectForm.sortType,
        memberSts: this.selectForm.memberSts,
        nickName: this.selectForm.nickName,
        authorizationType: this.selectForm.authorizationType,
        displayIs: this.selectForm.displayIs,
        topIs: this.selectForm.topIs,
        freeDisplayIs: this.selectForm.freeDisplayIs
      };
      if (this.selectForm.registerTime.length >= 2) {
        par.registerStartTime = this.selectForm.registerTime[0];
        par.registerEndTime = this.selectForm.registerTime[1];
      }
      if (this.selectForm.selectCitys.length > 0) {
        par.province = this.selectForm.selectCitys[0];
        par.city = this.selectForm.selectCitys[1];
        if (this.selectForm.selectCitys.length > 2) {
          par.area = this.selectForm.selectCitys[2];
        }
      }
      var apiUrl = 'admin/v1/member/exportMatchmakerMemberPageList';
      this.downloadUtil.excelExport(apiUrl, par, '红娘用户统计表.xls');
    },
    sortChange: function sortChange(op) {
      this.pageNo = 1;
      if (op === '1') {
        this.selectForm.sortType = 1;
      } else if (op === '2') {
        this.selectForm.sortType = 2;
      } else if (op === '3') {
        this.selectForm.sortType = 3;
      }
      this.initTableData();
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.registerTime = [];
      this.selectForm.noOrPhone = null;
      this.selectForm.membershipAuditSts = 0;
      this.selectForm.selectCitys = [];
      this.selectForm.memberStats = null;
      this.selectForm.memberSts = 0;
      this.selectForm.nickName = null;
      this.selectForm.authorizationType = null;
      this.selectForm.displayIs = 0;
      this.selectForm.topIs = null;
      this.selectForm.freeDisplayIs = null;
      this.initTableData();
    },
    memberNiceEditOpen: function memberNiceEditOpen(data) {
      console.log(data);
      this.dialogVisible = true;
      this.$refs.memberNiceNameEdit.setData(data);
    },
    memberNiceEditClose: function memberNiceEditClose() {
      this.dialogVisible = false;
    },
    getImagesImage: function getImagesImage(row) {
      if (row.headUrl.indexOf('http') !== -1) {
        return row.headUrl;
      }
      return this.downloadUrl + row.headUrl;
    },
    updateHomeTopApi: function updateHomeTopApi() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = [];
              _this.tableSelects.forEach(function (element) {
                par.push(element.memberId);
              });
              if (par.length === 0) {
                Message.error('请选择会员');
              } else {
                _this.$confirm('确定要取消推荐吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                  var index, id, proItem, _t, _t2;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        _t = _regeneratorKeys(par);
                      case 1:
                        if ((_t2 = _t()).done) {
                          _context.n = 3;
                          break;
                        }
                        index = _t2.value;
                        id = par[index];
                        proItem = {
                          memberId: id,
                          homeTop: 0
                        };
                        _context.n = 2;
                        return api.UPDATE_MEMBER(proItem);
                      case 2:
                        _context.n = 1;
                        break;
                      case 3:
                        _this.initTableData();
                        _this.$message.success('操作成功');
                      case 4:
                        return _context.a(2);
                    }
                  }, _callee);
                }))).catch(function () {
                  _this.$message({
                    type: 'info',
                    message: '已取消操作'
                  });
                });
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getCarPurchasesEnumList: function getCarPurchasesEnumList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                name: 'member_car_select'
              };
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context3.v;
              _this2.carPurchases = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getMarriagesEnumList: function getMarriagesEnumList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                name: 'mbmber_marriage_select'
              };
              _context4.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context4.v;
              _this3.marriages = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getBuyHousesEnumList: function getBuyHousesEnumList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                name: 'member_buyHouse_select'
              };
              _context5.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context5.v;
              _this4.buyHouses = res.body;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var par, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              par = {
                pageNo: _this5.pageNo,
                pageSize: _this5.pageSize,
                noOrPhone: _this5.selectForm.noOrPhone,
                membershipAuditSts: _this5.selectForm.membershipAuditSts,
                membership: 3,
                sortType: _this5.selectForm.sortType,
                memberSts: _this5.selectForm.memberSts,
                nickName: _this5.selectForm.nickName,
                authorizationType: _this5.selectForm.authorizationType,
                displayIs: _this5.selectForm.displayIs,
                topIs: _this5.selectForm.topIs,
                freeDisplayIs: _this5.selectForm.freeDisplayIs
              };
              if (_this5.selectForm.registerTime.length >= 2) {
                par.registerStartTime = _this5.selectForm.registerTime[0];
                par.registerEndTime = _this5.selectForm.registerTime[1];
              }
              if (_this5.selectForm.selectCitys.length > 0) {
                par.province = _this5.selectForm.selectCitys[0];
                par.city = _this5.selectForm.selectCitys[1];
                if (_this5.selectForm.selectCitys.length > 2) {
                  par.area = _this5.selectForm.selectCitys[2];
                }
              }
              _context6.n = 1;
              return api.getMatchmakerMemberPageList(par);
            case 1:
              res = _context6.v;
              _this5.tableData = res.body.datas;
              _this5.pageTotal = res.body.sumDataCount;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    },
    initProvinces: function initProvinces() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return api.GET_PROVINCE_LIST();
            case 1:
              res = _context7.v;
              _this6.provinces = res.body;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    initCitys: function initCitys() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return api.GET_BYCITYOPENING_SELECT_TREE_LIST({});
            case 1:
              res = _context8.v;
              _this7.citys = res.body;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    addWarningApi: function addWarningApi(data) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return api.ADD_MEMBER_WARNING(data);
            case 1:
              Message.success('操作成功');
              _this8.initTableData();
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    getMemberSumCounts: function getMemberSumCounts() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var res;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return api.GET_MEMBER_SUM_COUNT();
            case 1:
              res = _context0.v;
              _this9.memberSumCounts = res.body;
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    alert: function alert(data) {
      var _this0 = this;
      var msg = '冻结';
      if (data.memberSts !== 0) {
        msg = '解冻';
      }
      this.$confirm('此操作将' + msg + '该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this0.updateApi(data);
      }).catch(function () {
        _this0.$message({
          type: 'info',
          message: '已取消' + msg
        });
      });
    },
    updateDisPlayApi: function updateDisPlayApi(data) {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var pro;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              pro = {
                memberId: data.memberId,
                displayIs: data.displayIs === 0 ? 1 : 0
              };
              _context1.n = 1;
              return api.UPDATE_MEMBER(pro);
            case 1:
              Message.success('操作成功');
              _this1.initTableData();
            case 2:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    updateApi: function updateApi(data) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var pro;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              pro = {
                memberId: data.memberId,
                memberSts: data.memberSts === 0 ? 1 : 0
              };
              _context10.n = 1;
              return api.UPDATE_MEMBER(pro);
            case 1:
              Message.success('操作成功');
              _this10.initTableData();
            case 2:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    updateDisPlay: function updateDisPlay(data) {
      var _this11 = this;
      this.$confirm(data.displayIs === 0 ? '确定隐藏该用户吗？' : '确定取消隐藏该用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this11.updateDisPlayApi(data);
      }).catch(function () {
        _this11.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    updateFreeDisplayIs: function updateFreeDisplayIs(data) {
      var _this12 = this;
      this.$confirm(data.freeDisplayIs === 0 ? '确定推荐该用户吗？' : '确定取消推荐该用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this12.updateFreeDisplayIsApi(data);
      }).catch(function () {
        _this12.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    updateFreeDisplayIsApi: function updateFreeDisplayIsApi(data) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var pro;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              pro = {
                memberId: data.memberId,
                freeDisplayIs: data.freeDisplayIs === 0 ? 1 : 0
              };
              _context11.n = 1;
              return api.UPDATE_MEMBER(pro);
            case 1:
              Message.success('操作成功');
              _this13.initTableData();
            case 2:
              return _context11.a(2);
          }
        }, _callee11);
      }))();
    },
    updateTopIsApi: function updateTopIsApi(data) {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var pro;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              pro = {
                memberId: data.memberId,
                topIs: data.topIs === 0 ? 1 : 0
              };
              _context12.n = 1;
              return api.UPDATE_MEMBER(pro);
            case 1:
              Message.success('操作成功');
              _this14.initTableData();
            case 2:
              return _context12.a(2);
          }
        }, _callee12);
      }))();
    },
    updateTopIs: function updateTopIs(data) {
      var _this15 = this;
      this.$confirm(data.topIs === 0 ? '确定置顶该用户吗？' : '确定取消置顶该用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this15.updateTopIsApi(data);
      }).catch(function () {
        _this15.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    update: function update(data) {
      var _this16 = this;
      this.$confirm(data.memberSts === 0 ? '确定冻结该用户吗？' : '确定解冻该用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this16.updateApi(data);
      }).catch(function () {
        _this16.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initCitys();
    this.initTableData();
  }
};